<script setup lang="ts">
import { Comparison } from '@graphql/types/properties';
import { Sign } from '@graphql/enums/properties';

interface Props {
  currentValue: string;
  comparison: Comparison
}

const props = defineProps<Props>();
const icon = () => {
  if (props.comparison.sign === Sign.INCREASE) {
    return 'arrow-up';
  }

  if (props.comparison.sign === Sign.ZERO || props.comparison.sign === Sign.NO_DATA) {
    return 'arrow-up-arrow-down';
  }

  return 'arrow-down';
};

const color = () => {
  if (props.comparison.sign === Sign.INCREASE) {
    return 'text-secondary';
  }

  if (props.comparison.sign === Sign.ZERO || props.comparison.sign === Sign.NO_DATA) {
    return 'text-gray-400';
  }

  return 'text-red-600';
};

</script>

<template>
  <div class="flex items-center flex-wrap gap-4">
    <span class="text-primary leading-none text-2xl font-semibold sm:text-header-2">{{ props.currentValue }}</span>
    <div class="flex items-center gap-2 text-body">
      <FontAwesomeIcon
        :class="color()"
        :icon="['fas', icon()]"
      />
      <p>
        {{ props.comparison.value }}
        {{ props.comparison.sign !== Sign.ZERO && props.comparison.sign !== Sign.NO_DATA ? props.comparison.label : '' }}
      </p>
    </div>
  </div>
</template>
